import { CLOUDINARY_ENDPOINT } from '../consts/config';
import { IMAGE_DEFAULTS } from '../consts/image';
import { IDamImage } from '../models/content.interfaces';

export function getCloudinaryUrl(
  image: IDamImage,
  width?: number,
  formatAuto: boolean = true,
  quality: number = IMAGE_DEFAULTS.QUALITY,
): string {
  return `${CLOUDINARY_ENDPOINT}/q_${quality}${formatAuto ? ',f_auto' : ''}${
    width ? `,c_scale,w_${width}` : ''
  }/${image.sha}`;
}
